<div class="cta-simple-wrapper player-common-component">

  <div class="space-wrapper"></div>

  <div class="content" *ngIf="ctaSimple">
    <div class="overlay-cta-btn">
      <a [attr.href]="ctaSimple.linkUrl" (click)="ctaClicked()" target="_blank">
        <div class="overlay-cta-btn-container primary-color">
          <span class="overlay-cta-btn-text">{{ctaSimple.title}}</span>
          <span class="material-icons">chevron_right</span>
        </div>
      </a>
    </div>
  </div>

  <div class="controls-wrapper">
    <div class="back-forward">

      <div class="forward btn show"></div>

      <div class="center btn show" *ngIf="! ctaSimple.trigger" (click)="closeCta()">
        <mat-icon class="material-icons-rounded">close</mat-icon>閉じる
      </div>

      <div class="center btn show" *ngIf="ctaSimple.trigger" (click)="forwardClicked()">
        次へ<mat-icon class="material-icons-rounded">arrow_forward_ios</mat-icon>
      </div>

      <div class="forward btn show"></div>

    </div>
  </div>

</div>
